import { render, staticRenderFns } from "./CardioAnalysisInfoItem.vue?vue&type=template&id=2cc64fe8&"
import script from "./CardioAnalysisInfoItem.vue?vue&type=script&lang=js&"
export * from "./CardioAnalysisInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports